import React, { useState } from 'react';
import { Package, Search, Filter, Plus, ArrowUpRight, ArrowDownRight, History, AlertCircle, MoreVertical, Edit2, Trash2, X as CloseIcon, Tag, DollarSign, Layers } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function InventoryMgmtView() {
  const [showAddModal, setShowAddModal] = useState(false);
  const [inventory, setInventory] = useState([{
    id: 1,
    name: 'Atlantic Salmon',
    category: 'Seafood',
    stock: '4.2 lbs',
    unit: 'lbs',
    status: 'Low Stock',
    price: '$18.50'
  }, {
    id: 2,
    name: 'Heavy Cream',
    category: 'Dairy',
    stock: '2 qts',
    unit: 'qts',
    status: 'Low Stock',
    price: '$4.20'
  }, {
    id: 3,
    name: 'Brioche Buns',
    category: 'Bakery',
    stock: '12 units',
    unit: 'units',
    status: 'Critical',
    price: '$0.85'
  }, {
    id: 4,
    name: 'Ribeye Steak',
    category: 'Meat',
    stock: '45 lbs',
    unit: 'lbs',
    status: 'In Stock',
    price: '$22.00'
  }, {
    id: 5,
    name: 'Yukon Gold Potatoes',
    category: 'Produce',
    stock: '120 lbs',
    unit: 'lbs',
    status: 'In Stock',
    price: '$1.10'
  }, {
    id: 6,
    name: 'Extra Virgin Olive Oil',
    category: 'Dry Goods',
    stock: '15 liters',
    unit: 'liters',
    status: 'In Stock',
    price: '$12.50'
  }]);
  return <div className="space-y-6" data-id="element-217">
      {/* Add Item Modal */}
      <AnimatePresence data-id="element-218">
        {showAddModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[110] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4" data-id="element-219">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0,
          y: 20
        }} animate={{
          scale: 1,
          opacity: 1,
          y: 0
        }} exit={{
          scale: 0.9,
          opacity: 0,
          y: 20
        }} className="w-full max-w-lg bg-white rounded-[32px] shadow-2xl overflow-hidden" data-id="element-220">
              <div className="p-8" data-id="element-221">
                <div className="flex justify-between items-start mb-8" data-id="element-222">
                  <div className="w-12 h-12 bg-emerald-100 rounded-2xl flex items-center justify-center text-emerald-600" data-id="element-223">
                    <Plus size={24} data-id="element-224" />
                  </div>
                  <button onClick={() => setShowAddModal(false)} className="p-2 hover:bg-slate-100 rounded-full transition-colors text-slate-400" data-id="element-225">
                    <CloseIcon size={20} data-id="element-226" />
                  </button>
                </div>

                <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-227">
                  Add New Inventory Item
                </h3>
                <p className="text-slate-500 text-sm mb-8" data-id="element-228">
                  Enter the details of the new item to track in your inventory.
                </p>

                <div className="space-y-4 mb-8" data-id="element-229">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-230">
                    <div className="md:col-span-2" data-id="element-231">
                      <label className="block text-xs font-bold text-slate-700 mb-2 uppercase tracking-wider" data-id="element-232">
                        Item Name
                      </label>
                      <div className="relative" data-id="element-233">
                        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-234">
                          <Tag size={18} className="text-slate-400" data-id="element-235" />
                        </div>
                        <input type="text" placeholder="e.g. Atlantic Salmon" className="w-full pl-11 pr-4 py-3 bg-slate-50 border border-slate-100 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 transition-all" data-id="element-236" />
                      </div>
                    </div>

                    <div data-id="element-237">
                      <label className="block text-xs font-bold text-slate-700 mb-2 uppercase tracking-wider" data-id="element-238">
                        Category
                      </label>
                      <div className="relative" data-id="element-239">
                        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-240">
                          <Layers size={18} className="text-slate-400" data-id="element-241" />
                        </div>
                        <select className="w-full pl-11 pr-4 py-3 bg-slate-50 border border-slate-100 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 transition-all appearance-none" data-id="element-242">
                          <option data-id="element-243">Seafood</option>
                          <option data-id="element-244">Meat</option>
                          <option data-id="element-245">Produce</option>
                          <option data-id="element-246">Dairy</option>
                          <option data-id="element-247">Bakery</option>
                          <option data-id="element-248">Dry Goods</option>
                        </select>
                      </div>
                    </div>

                    <div data-id="element-249">
                      <label className="block text-xs font-bold text-slate-700 mb-2 uppercase tracking-wider" data-id="element-250">
                        Unit Price
                      </label>
                      <div className="relative" data-id="element-251">
                        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-252">
                          <DollarSign size={18} className="text-slate-400" data-id="element-253" />
                        </div>
                        <input type="number" placeholder="0.00" className="w-full pl-11 pr-4 py-3 bg-slate-50 border border-slate-100 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 transition-all" data-id="element-254" />
                      </div>
                    </div>

                    <div data-id="element-255">
                      <label className="block text-xs font-bold text-slate-700 mb-2 uppercase tracking-wider" data-id="element-256">
                        Initial Stock
                      </label>
                      <input type="number" placeholder="0" className="w-full px-4 py-3 bg-slate-50 border border-slate-100 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 transition-all" data-id="element-257" />
                    </div>

                    <div data-id="element-258">
                      <label className="block text-xs font-bold text-slate-700 mb-2 uppercase tracking-wider" data-id="element-259">
                        Unit Type
                      </label>
                      <select className="w-full px-4 py-3 bg-slate-50 border border-slate-100 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 transition-all appearance-none" data-id="element-260">
                        <option data-id="element-261">lbs</option>
                        <option data-id="element-262">oz</option>
                        <option data-id="element-263">units</option>
                        <option data-id="element-264">qts</option>
                        <option data-id="element-265">liters</option>
                        <option data-id="element-266">cases</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="flex gap-3" data-id="element-267">
                  <button onClick={() => setShowAddModal(false)} className="flex-1 py-3 px-4 bg-slate-100 hover:bg-slate-200 text-slate-600 rounded-xl text-sm font-bold transition-all" data-id="element-268">
                    Cancel
                  </button>
                  <button onClick={() => setShowAddModal(false)} className="flex-1 py-3 px-4 bg-emerald-500 hover:bg-emerald-600 text-white rounded-xl text-sm font-bold shadow-lg shadow-emerald-500/20 transition-all" data-id="element-269">
                    Add to Inventory
                  </button>
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      <div className="flex items-center justify-between" data-id="element-270">
        <div data-id="element-271">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-272">
            Inventory Management System
          </h2>
          <p className="text-sm text-slate-500" data-id="element-273">
            Real-time stock tracking and replenishment
          </p>
        </div>
        <div className="flex items-center gap-3" data-id="element-274">
          <button className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-xl text-xs font-bold text-slate-600 hover:bg-slate-50 transition-all shadow-sm" data-id="element-275">
            <History size={14} data-id="element-276" />
            Audit Log
          </button>
          <button onClick={() => setShowAddModal(true)} className="flex items-center gap-2 px-6 py-2 bg-emerald-500 text-white rounded-xl text-sm font-bold shadow-lg shadow-emerald-500/20 hover:bg-emerald-600 transition-all" data-id="element-277">
            <Plus size={16} data-id="element-278" />
            Add Item
          </button>
        </div>
      </div>

      {/* Stats Overview */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-279">
        <StatCard title="Total Items" value="1,240" icon={Package} color="blue" data-id="element-280" />
        <StatCard title="Low Stock Alerts" value="12" icon={AlertCircle} color="amber" data-id="element-281" />
        <StatCard title="Inventory Value" value="$42,500" icon={ArrowUpRight} color="emerald" data-id="element-282" />
      </div>

      {/* Inventory Table */}
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden" data-id="element-283">
        <div className="p-4 border-b border-slate-50 flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-284">
          <div className="relative flex-1 max-w-md" data-id="element-285">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} data-id="element-286" />
            <input type="text" placeholder="Search inventory by name, category, or SKU..." className="w-full pl-10 pr-4 py-2 bg-slate-50 border border-slate-100 rounded-xl text-sm focus:bg-white focus:ring-2 focus:ring-emerald-500/10 focus:border-emerald-500 outline-none transition-all" data-id="element-287" />
          </div>
          <div className="flex items-center gap-2" data-id="element-288">
            <button className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-50 rounded-lg transition-all" data-id="element-289">
              <Filter size={18} data-id="element-290" />
            </button>
            <div className="h-4 w-[1px] bg-slate-200 mx-1" data-id="element-291" />
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-292">
              Showing {inventory.length} Items
            </p>
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-293">
          <table className="w-full text-left" data-id="element-294">
            <thead data-id="element-295">
              <tr className="bg-slate-50/50" data-id="element-296">
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-297">
                  Item Name
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-298">
                  Category
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-299">
                  Stock Level
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-300">
                  Unit Price
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-301">
                  Status
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-right" data-id="element-302">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50" data-id="element-303">
              {inventory.map(item => <tr key={item.id} className="hover:bg-slate-50 transition-colors group" data-id="element-304">
                  <td className="px-6 py-4" data-id="element-305">
                    <span className="text-sm font-bold text-slate-900" data-id="element-306">
                      {item.name}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-307">
                    <span className="px-2 py-1 bg-slate-100 text-slate-600 text-[10px] font-bold rounded-md uppercase" data-id="element-308">
                      {item.category}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm font-black text-slate-900" data-id="element-309">
                    {item.stock}
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-slate-500" data-id="element-310">
                    {item.price}
                  </td>
                  <td className="px-6 py-4" data-id="element-311">
                    <span className={`flex items-center gap-1.5 text-[10px] font-bold ${item.status === 'In Stock' ? 'text-emerald-600' : item.status === 'Low Stock' ? 'text-amber-600' : 'text-rose-600'}`} data-id="element-312">
                      <div className={`w-1.5 h-1.5 rounded-full ${item.status === 'In Stock' ? 'bg-emerald-500' : item.status === 'Low Stock' ? 'bg-amber-500' : 'bg-rose-500'}`} data-id="element-313" />
                      {item.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-314">
                    <div className="flex items-center justify-end gap-1" data-id="element-315">
                      <button className="p-2 text-slate-300 hover:text-slate-600 transition-colors" data-id="element-316">
                        <Edit2 size={14} data-id="element-317" />
                      </button>
                      <button className="p-2 text-slate-300 hover:text-rose-500 transition-colors" data-id="element-318">
                        <Trash2 size={14} data-id="element-319" />
                      </button>
                      <button className="p-2 text-slate-300 hover:text-slate-600 transition-colors" data-id="element-320">
                        <MoreVertical size={14} data-id="element-321" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}
function StatCard({
  title,
  value,
  icon: Icon,
  color
}: any) {
  const colors: any = {
    emerald: 'bg-emerald-50 text-emerald-600',
    blue: 'bg-blue-50 text-blue-600',
    amber: 'bg-amber-50 text-amber-600'
  };
  return <div className="bg-white p-5 rounded-2xl border border-slate-100 shadow-sm" data-id="element-322">
      <div className="flex items-center gap-4" data-id="element-323">
        <div className={`p-3 rounded-xl ${colors[color]}`} data-id="element-324">
          <Icon size={20} data-id="element-325" />
        </div>
        <div data-id="element-326">
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-0.5" data-id="element-327">
            {title}
          </p>
          <p className="text-xl font-black text-slate-900" data-id="element-328">{value}</p>
        </div>
      </div>
    </div>;
}